import React, {useState} from 'react';
import {Button, Modal} from 'antd';
import {observer} from 'mobx-react';
import store from "./store";

import AddressList from "./List"
import AddressForm from "./Form"

import styles from '../layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function () {
  const { t } = useTranslation();
  const [visible, visibleUpdate] = useState(false)
  const [isAdd, isAddUpdate] = useState(false)
  const address = {
    area: ""
    , city: ""
    , customer_id: ''
    , details: ""
    , id: ''
    , is_default: false
    , is_del: false
    , name: ""
    , phone: ""
    , post: ""
    , province: ""
    , remark: ""
  }

  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('收货地址')}</span>
        </div>
        <div className="mainBox">
          <div className={styles.address}>
            <div className={styles.list}>
              <AddressList setVisible={() => {
                visibleUpdate(true)
                isAddUpdate(false)
              }}/>
            </div>
          </div>

          <div className={styles.add}>
            <Button type='primary' size='large' onClick={() => {
              store.address = address
              isAddUpdate(true)
              visibleUpdate(true)
            }}>{t('新增收货地址')}</Button>
          </div>


          <Modal
            title={isAdd ? t('新增收货地址') : t('编辑收货地址')}
            footer={false}
            centered
            getContainer={false}
            visible={visible}
            onOk={() => visibleUpdate(false)}
            onCancel={() => visibleUpdate(false)}
            width={768}
          >
            <AddressForm setVisible={()=>{visibleUpdate(false)}}/>
          </Modal>


        </div>

      </div>
    </React.Fragment>
  )
})
